/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SecurityModule
 */

import { IJWTServerProfile } from 'generated-types';
import { withFullModalMixin } from 'ajs/js/utilities/mixins';
import { ObjectTypeItem } from 'ajs/modules/data-model/factories/object-type-item.factory';
import { JWTServerProfileModalComponent } from 'ng/modules/security';

export const jwtServerProfileToken = 'JWTServerProfile';

interface IJWTServerProfileData {
    config: IJWTServerProfile;
}

/**
 * @description
 *
 *   JWT Server Profile item.
 *
 * @author Rachit Aggarwal
 */
export class JWTServerProfile extends withFullModalMixin(ObjectTypeItem) {
    public data: IJWTServerProfileData;
    public getConfig: () => IJWTServerProfile;

    constructor(args = {}) {
        const extendedArgs = {
            ...args,
            objectName: 'jwtserverprofile',
            objectType: jwtServerProfileToken,
            permissionName: 'PERMISSION_JWTSERVERPROFILE',
            windowElement: JWTServerProfileModalComponent,
        };

        super(extendedArgs);
    }

    /**
     * Returns type of the item object.
     */
    public get messageType(): string {
        return this.objectType;
    }

    /**
     * Initialize MessageItems before editing.
     * @override
     */
    protected beforeEdit(): void {
        if (!this.config.protected_resource_config) {
            this.safeSetNewChildByField('protected_resource_config', {
                enable_protected_resource_metadata: false,
                metadata_url_path: '/.well-known/oauth-protected-resource',
                authorization_servers: [],
                supported_scopes: [],
                resource_documentation: '',
            });
        }
    }

    /**
     * Remove protected_resource_config from payload when feature is disabled.
     * @override
     */
    public dataToSave(): IJWTServerProfile {
        const config = super.dataToSave();

        if (!config.protected_resource_config) {
            return config;
        }

        if (!config.protected_resource_config.enable_protected_resource_metadata) {
            delete config.protected_resource_config;
        } else {
            if (config.protected_resource_config.authorization_servers &&
                config.protected_resource_config.authorization_servers.length === 0) {
                delete config.protected_resource_config.authorization_servers;
            }

            if (config.protected_resource_config.supported_scopes &&
                config.protected_resource_config.supported_scopes.length === 0) {
                delete config.protected_resource_config.supported_scopes;
            }
        }

        return config;
    }
}
